import { createSelector } from 'reselect';

export const getRentIncrease = state => state.rentIncrease;

export const getIsRentIncreaseListOpen = createSelector(
    [getRentIncrease],
    rentIncrease => rentIncrease.isRentIncreaseLeaseListModalOpen
);
